// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { ErrorInformationStorage } from '@shared/commons/ErrorInformationStorage';
import { Resources } from '@shared/localizations/Resources';
import { FieldsFactory } from '../Factory/FieldsFactory';
import { PFixField } from './PFixField';
// TODO. Params object.
export class PFixFieldSet {
    constructor(groupId, buffer, pfixFieldSet) {
        this.GroupId = -1;
        this.fieldSet = [];
        if (groupId && groupId !== null) {
            this.GroupId = groupId;
        }
        this.factory = FieldsFactory.getInstance();
        if (buffer && buffer !== null) {
            this.Read(buffer);
        }
        // TODO. Ok? Don't want to copy entire fieldset.
        if (pfixFieldSet) {
            this.fieldSet = pfixFieldSet.fieldSet;
        }
    }
    Count() {
        return this.fieldSet.length;
    }
    Read(buffer) {
        while (!buffer.EndOfBuffer()) {
            const fieldId = buffer.ReadShort();
            const field = this.factory.getFieldById(fieldId);
            if (field != null) {
                field.ReadValue(buffer);
                this.SetField(field);
            }
            else {
                break;
            }
        }
    }
    Write(buffer, maxServerNumber) {
        const fieldSet = this.fieldSet;
        const count = fieldSet.length;
        for (let i = count - 1; i >= 0; i--) {
            const field = fieldSet[i];
            if (field.FieldId <= maxServerNumber) {
                field.Write(buffer, maxServerNumber);
            }
        }
    }
    GetField(field) {
        // field может быть как самим филдом, так и номером
        if (typeof field !== 'number') {
            field = field.FieldId;
        }
        const fieldSet = this.fieldSet;
        const count = fieldSet.length;
        for (let i = count - 1; i >= 0; i--) {
            const fixField = fieldSet[i];
            if (fixField.FieldId === field) {
                return fixField;
            }
        }
        return null;
    }
    GetGroups(groupId, GroupCtor) {
        const res = [];
        const fieldSet = this.fieldSet;
        const len = fieldSet.length;
        for (let i = 0; i < len; i++) {
            const fixField = fieldSet[i];
            if (fixField.FieldId === FieldsFactory.FIELD_GROUP) {
                const fields = fixField.Value;
                if (fields.GroupId === groupId) {
                    res.push(GroupCtor ? new GroupCtor(fields) : fields);
                }
            }
        }
        return res;
    }
    GetGroup(groupId) {
        const fieldSet = this.fieldSet;
        const len = fieldSet.length;
        for (let i = 0; i < len; i++) {
            const field = fieldSet[i];
            if (field.FieldId !== FieldsFactory.FIELD_GROUP) {
                continue;
            }
            const fields = field.Value;
            if (fields.GroupId === groupId) {
                return fields;
            }
        }
        return null;
    }
    IsSetField(field) {
        return this.GetField(field) !== null;
    }
    GetValue(field) {
        const fixField = this.GetField(field);
        return fixField !== null ? fixField.Value : null;
    }
    SetField(field, value) {
        // field может быть как самим филдом, так и номером
        if (typeof field !== 'number') {
            value = field.Value;
            field = field.FieldId;
        }
        let fixField = field !== FieldsFactory.FIELD_GROUP ? this.GetField(field) : null;
        if (fixField != null) {
            // групп может быть много, на каждую создаем свое поле
            fixField.Value = value;
        }
        else {
            fixField = this.factory.getFieldById(field);
            fixField.Value = value;
            this.fieldSet.push(fixField);
        }
    }
    SetFields(fields) {
        const fieldSet = fields.fieldSet;
        const count = fieldSet.length;
        for (let i = count - 1; i >= 0; i--) {
            this.fieldSet.push(fieldSet[i]);
        }
    }
    AddGroup(value) {
        this.SetField(FieldsFactory.FIELD_GROUP, value);
    }
    static SerealizeForWorkerStatic(fieldSet) {
        const result = [];
        let i = 0;
        const len = fieldSet.length;
        for (i; i < len; i++) {
            const fs = fieldSet[i];
            if (fs.FieldId === 74) {
                result.push({
                    FieldId: fs.FieldId,
                    Value: PFixFieldSet.SerealizeForWorkerStatic(fs.Value.fieldSet),
                    GroupId: fs.Value.GroupId
                });
            }
            else {
                result.push({ FieldId: fs.FieldId, Value: fs.Value });
            }
        }
        return result;
    }
    static DeSerealizeForWorkerStatic(fieldSet) {
        const result = new PFixFieldSet();
        let i = 0;
        const len = fieldSet.length;
        for (i; i < len; i++) {
            const fs = fieldSet[i];
            const field = new PFixField();
            if (fs.FieldId === 74) {
                field.FieldId = fs.FieldId;
                field.Value = PFixFieldSet.DeSerealizeForWorkerStatic(fs.Value);
                field.Value.GroupId = fs.GroupId;
            }
            else {
                field.FieldId = fs.FieldId;
                field.Value = fs.Value;
            }
            result.fieldSet.push(field);
        }
        return result;
    }
    toString() {
        try {
            if (this.fieldSet == null) {
                return '[Empty]';
            }
            let sb = '';
            for (let i = 0; i < this.fieldSet.length; i++) {
                const field = this.fieldSet[i];
                sb += field.FieldId;
                sb += '=';
                if (field.FieldId === FieldsFactory.FIELD_COMPRESSED_DATA) {
                    sb += field.Value !== null ? '[]' : '';
                }
                else {
                    sb += field.Value !== null ? field.SerializeValue() : '';
                }
                sb += ';';
                sb += ' ';
            }
            return sb;
        }
        catch (ex) {
            // ErrorInformationStorage.GetException(ex);
            console.log(ex + '  Critical error in FieldSet::toString');
            return '[Empty]';
        }
    }
    ToStringView() {
        try {
            if (this.fieldSet == null) {
                return '[Empty]';
            }
            let sb = '';
            const code = this.GetValue(FieldsFactory.FIELD_MSG_TYPE);
            sb += "Code='" + FieldsFactory.GetMsgTypeName(code) + "' ";
            for (let i = 0; i < this.fieldSet.length; i++) {
                const field = this.fieldSet[i];
                if (field.FieldId === FieldsFactory.FIELD_MSG_TYPE) {
                    continue;
                }
                sb += FieldsFactory.GetFieldName(field.FieldId);
                sb += '=';
                if (field.FieldId === FieldsFactory.FIELD_GROUP) {
                    sb += '{';
                    sb += field.Value.ToStringView();
                    sb += '}';
                }
                else if (field.FieldId === FieldsFactory.FIELD_PASSWORD ||
                    field.FieldId === FieldsFactory.FIELD_VERIFICATION_PASSWORD ||
                    field.FieldId === FieldsFactory.FIELD_BRANDING_KEY) {
                    // для пассворда подменяю содержимое на *, по требованию trade.tradeall.com:80, да и в принципе, логично.
                    sb += "'";
                    sb += field.Value != null ? '*' /* new string('*', field.Value.toString().Length) */ : 'null';
                    sb += "'";
                }
                else if (field.FieldId === FieldsFactory.FIELD_CLIENT_PANEL_ID ||
                    field.FieldId === FieldsFactory.FIELD_CLIENT_PANEL) {
                    sb += "'";
                    sb +=
                        field.Value != null
                            ? Resources.getResource('reports.' /* + Enum.GetName(typeof (PlacedFrom), */ + field.Value)
                            : '';
                    sb += "'";
                }
                else if (field.FieldId === FieldsFactory.FIELD_TIMESTAMP) {
                    sb += "'";
                    sb += field.Value != null ? field.SerializeValue() : '';
                    sb += "'";
                }
                else if (field.FieldId === FieldsFactory.FIELD_COMPRESSED_DATA) {
                    sb += "'";
                    sb += '[]';
                    sb += "'";
                }
                else {
                    sb += "'";
                    sb += field.Value;
                    sb += "'";
                }
                sb += ' ';
            }
            return sb;
        }
        catch (ex) {
            ErrorInformationStorage.GetException(ex);
            console.log(ex + '  Critical error in FieldSet::toString');
            return '[Empty]';
        }
    }
    GetData() {
        const array = [];
        const code = this.GetValue(FieldsFactory.FIELD_MSG_TYPE);
        array.push("Code='" + FieldsFactory.GetMsgTypeName(code) + "' ");
        array.push(this.GetDataRecursive());
        return array;
    }
    GetDataRecursive() {
        const array = [];
        for (const field of this.fieldSet) {
            const { FieldId, Value } = field;
            if (FieldId === FieldsFactory.FIELD_MSG_TYPE)
                continue;
            if (FieldId === FieldsFactory.FIELD_GROUP) {
                array.push(`Group='${FieldsFactory.GetGroupName(Value.GroupId)}'`);
                array.push(Value.GetDataRecursive());
                continue;
            }
            let node = `${FieldsFactory.GetFieldName(FieldId)}=`;
            const wrap = (val) => `'${val}'`;
            switch (FieldId) {
                case FieldsFactory.FIELD_PASSWORD:
                case FieldsFactory.FIELD_VERIFICATION_PASSWORD:
                    node += Value != null ? wrap('*') : wrap('null');
                    break;
                case FieldsFactory.FIELD_CLIENT_PANEL_ID:
                case FieldsFactory.FIELD_CLIENT_PANEL:
                    node += Value != null ? wrap(Resources.getResource(`reports.${Value}`)) : wrap('');
                    break;
                case FieldsFactory.FIELD_TIMESTAMP:
                    node += Value != null ? wrap(field.SerializeValue()) : wrap('');
                    break;
                case FieldsFactory.FIELD_MESSAGE_CODES:
                    node += Value != null ? wrap(field.toString()) : wrap('');
                    break;
                case FieldsFactory.FIELD_COMPRESSED_DATA:
                    node += Value != null ? wrap('[]') : wrap('');
                    break;
                default:
                    node += wrap(Value != null ? Value.toString() : Value);
                    break;
            }
            array.push(node);
        }
        return array;
    }
    GetSendableObject() {
        const result = {};
        const length = this.fieldSet.length;
        result.GroupId = this.GroupId;
        result.fieldSet = [];
        for (let i = 0; i < length; i++) {
            const field = this.fieldSet[i];
            if (field.FieldId === 74) {
                result.fieldSet.push(this.GetSendableObjectFromField(field));
            }
            else {
                result.fieldSet.push(field);
            }
        }
        return result;
    }
    GetSendableObjectFromField(field) {
        const result = {};
        const length = field.Value.fieldSet.length;
        result.FieldId = field.FieldId;
        result.Value = {};
        const value = result.Value;
        value.GroupId = field.Value.GroupId;
        value.fieldSet = [];
        for (let i = 0; i < length; i++) {
            const fieldIn = field.Value.fieldSet[i];
            if (fieldIn.FieldId === 74) {
                value.fieldSet.push(this.GetSendableObjectFromField(fieldIn));
            }
            else {
                value.fieldSet.push(fieldIn);
            }
        }
        return result;
    }
}
